module.exports = __webpack_public_path__ + "img/bilibili-winter-view-2.ba9c6589.ba9c6589.jpg";